import {ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Optional, Output} from "@angular/core";
import {IntTableColumnsLimiterItemDirective} from "./int-table-columns-limiter-item.directive";
import {IntTableColumnsLimiterService} from "./int-table-columns-limiter.service";

@Component({
  selector: 'int-table-columns-limiter-dropdown',
  template: `
    <int-target-dropdown
      [dropdownWidth]="200"
      [dropdownHeight]="'35rem'"
      [positions]="['left']"
      [verticalAlign]="'start'"
      [horizontalOffset]="10"
      [show]="isShow"
    >
      <ng-container ngProjectAs="target">
        <ng-content></ng-content>
        <int-badge *ngIf="!isShowAll" class="badge" size="sm" mode="danger">e</int-badge>
      </ng-container>
      <ng-container ngProjectAs="content">
        <int-table-columns-limiter
          [hideOnLoadList]="hideOnLoadList"
          (onSelect)="onSelect.emit($event)"
        >
          <ng-container ngProjectAs="show-all-label">
            <ng-content select="show-all-label"></ng-content>
          </ng-container>

          <ng-template intTableColumnsLimiterItem let-payload>
            <ng-container *ngTemplateOutlet="itemTemplate.templateRef; context: {$implicit: payload}"></ng-container>
          </ng-template>

        </int-table-columns-limiter>
      </ng-container>
    </int-target-dropdown>
  `,
  styles: [`
    .badge {
      position: absolute;
      right: -0.2rem;
      top: -0.2rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntTableColumnsLimiterDropdownComponent<T extends object> {
  @Input() hideOnLoadList: Array<string> | null = null;
  @Input() isShow = false;

  @Output() onSelect = new EventEmitter<Array<T>>();

  @ContentChild(IntTableColumnsLimiterItemDirective) readonly itemTemplate!: IntTableColumnsLimiterItemDirective;

  constructor(
    @Optional()
    readonly columnsService: IntTableColumnsLimiterService<T>,
  ) {
  }

  get isShowAll() {
    return this.columnsService?.isAllVisible;
  }
}
